import { useBoolean } from "ahooks";
import { Fragment, memo, useCallback, useMemo } from "react";
import { type ReportErrorInput } from "hooks";
import ErrorReportDialog from "./ErrorReportDialog";

interface ErrorReportProps {
  origin: string;
  error: string;
  details: string;
  renderTrigger: (openDialog: () => void) => React.ReactNode;
  onComplete?: () => void;
}

const ErrorReport = memo<ErrorReportProps>(
  ({ origin, error, details, renderTrigger, onComplete }) => {
    const [isDialogOpen, { setFalse: closeDialog, setTrue: openDialog }] =
      useBoolean(false);
    const handleFinish = useCallback(() => {
      onComplete?.();
      closeDialog();
    }, [closeDialog, onComplete]);
    const defaultDetails = useMemo(
      () =>
        `Context: ${origin}\nError message: ${error}\nError details: ${details}`,
      [error, details, origin]
    );
    const handleGenerateReport = useCallback(
      async (details: string) => {
        const report: ReportErrorInput = {
          details: details || "",
          errorContext: [],
          origin,
        };
        return report;
      },
      [origin]
    );
    return (
      <Fragment>
        {renderTrigger(openDialog)}
        <ErrorReportDialog
          defaultDetails={defaultDetails}
          generateReport={handleGenerateReport}
          onCancel={closeDialog}
          onFinish={handleFinish}
          open={isDialogOpen}
        />
      </Fragment>
    );
  }
);
ErrorReport.displayName = "ErrorReport";

export default ErrorReport;
